import { TableNode } from '@table-library/react-table-library';
import { useState } from 'react';
import { useTablesConfig } from 'store/state';
import { Table } from '..';
import { IMagellanTableProps } from '../table/Table';
import './FooterTable.scss';

const FooterTable = <T extends TableNode>({
  ...props
}: IMagellanTableProps<T>) => {
  //--data-table-library_grid-template-columns: repeat(minmax(0px, 1fr)) minmax(0px, 1fr) minmax(0px, 1fr) minmax(0px, 1fr) minmax(0px, 1fr);

  const tablesConfig = useTablesConfig();

  const [layoutChange, setLayoutChange] = useState(
    `repeat(${props.columns.length}, minmax(0px, 1fr))`
  );

  const footerDisplay = !!props.columns.find(c => !!c.footer);

  const isEmptyData = !props.data.nodes.length;

  const tableColumns = props.columns.map(({ footer, ...rest }) => rest);

  return (
    <div className='magellan-table-footer-wrapper'>
      <Table
        {...props}
        columns={tableColumns}
        layout={{
          fixedHeader: true,
          ...props.layout,
        }}
      />
      {footerDisplay && !isEmptyData && (
        <div
          className='magellan-table-footer'
          style={{
            gridTemplateColumns: props.id ? tablesConfig[props.id]?.grid : layoutChange,
          }}>
          {props.columns
            .filter(c => !c.hide)
            .map((c, k) => (
              <div key={k} className='magellan-table-footer-column'>
                {c.footer ?? ' '}
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default FooterTable;
